<template>
  <c-box v-show="isVisible">
    <slot></slot>
  </c-box>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { CBox } from "@chakra-ui/vue";

export default defineComponent({
  name: "WizardPage",
  components: {
    CBox,
  },
  props: {
    title: String,
    name: { type: String, required: true },
    step: { type: Number, required: true },
    submitPage: Boolean,
    finalPage: Boolean,
    preventNavigation: Boolean,
    errors: Boolean,
    validationPromise: null as any,
    validationParams: { type: Array, default: () => [] },
    disabled: Boolean,
    leavePromise: null as any,
  },
  data() {
    return {
      isActivated: false,
      isVisible: false,
      isVisited: false,
      isDisabled: false,
    };
  },
  created() {
    if (this.disabled) {
      this.isDisabled = true;
    }
    this.$emit("addPage", this);
  },
  beforeDestroy() {
    this.$emit("removePage", this);
  },
  methods: {
    show() {
      this.isVisible = true;
      this.isVisited = true;
    },
    hide() {
      this.isVisible = false;
    },
    activate() {
      this.isActivated = true;
    },
    deactivate() {
      this.isActivated = false;
    },
  },
});
</script>
